export const STORAGE_KEY = 'INDICO_USER';
export const STORAGE_VALUE_EMAIL = 'USER_EMAIL';
export const PARAM_AUTH_REDIRECT_KEY = 'redirect_url';
export const PARAM_TOKEN_KEY = 'token';
export const TOAST_TIMEOUT = 5000;
